<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Chèques clients",
          icon: "bi bi-cash-stack",
          route: "checks-customers-index",
        },
        {
          label: "Nouveau chèque client",
          icon: "bi bi-plus-lg",
          route: "checks-customers-create",
        },
        {
          label: "En attente",
          icon: "bi bi-clock-history",
          route: "checks-customers-pending",
        },
        {
          label: "Payés",
          icon: "bi bi-check-circle-fill",
          route: "checks-customers-paid",
        },
        {
          label: "Impayés",
          icon: "bi bi-x-circle-fill",
          route: "checks-customers-unpaid",
        },
        {
          label: "Remarquées",
          icon: "bi bi-bookmark-star-fill",
          route: "checks-customers-noticed",
        },
        {
          label: "Chèques fournisseurs",
          icon: "bi bi-bank",
          route: "checks-suppliers-index",
        },
        {
          label: "Nouveau chèque fournisseur",
          icon: "bi bi-plus-square-fill",
          route: "checks-suppliers-create",
        },
      ],
    };
  },
};
</script>
